import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Resource} from '../../../graphql/resources.datatypes';

interface AvailableToursData {
    availableTours: Resource[],
}

export const GET_AVAILABLE_TOURS_QUERY = gql`
    query availableTours{
        availableTours {
            id
            internal_name
            available_from
            available_to
            max_nights_before
            max_nights_after
            max_additional_nights
            credit_card_fee {
                id
                fee
            }    
        }
    }
`;

export const availableTours = () => {
    return useQuery<AvailableToursData>(
        GET_AVAILABLE_TOURS_QUERY,
        {
            variables: {}
        }
    );
};

export default availableTours;
